// import { message } from "antd";
// import { createSlice } from "@reduxjs/toolkit";

// import { IAuthState } from "@types";
// import { authApi } from "@services";

// const initialState: IAuthState = {
//   user: null,
//   token: {
//     access: null,
//     refresh: null,
//   },
//   permissions: [],
//   applications: [],
//   is_one_time_password: false,
// };

// const slice = createSlice({
//   name: "auth",
//   initialState,
//   reducers: {
//     addUserInState: (state, { payload }) => {
//       state.is_one_time_password = payload?.is_one_time_password;
//       state.user = payload?.user;
//       state.token = payload?.token;
//       state.permissions = !payload?.permissions?.length
//         ? ["all"]
//         : payload?.permissions;
//     },
//   },
//   extraReducers: builder => {
//     builder
//       .addMatcher(authApi.endpoints.logout.matchPending, (state, action) => {
//         state.user = null;
//         message.success(`User has been successfully logout`);
//       })
//       .addMatcher(
//         authApi.endpoints.verify.matchFulfilled,
//         (state, { payload }) => {
//           if (payload?.data?.is_one_time_password) {
//             state.is_one_time_password = payload?.data?.is_one_time_password;
//             state.token.access = payload?.data?.token;
//           } else {
//             state.is_one_time_password = payload?.data?.is_one_time_password;
//             state.user = payload?.data?.user;
//             state.token = payload?.data?.token;
//             state.applications =
//               payload?.data?.user?.company?.applications || [];
//             state.permissions = !payload?.data?.permissions?.length
//               ? ["all"]
//               : payload?.data?.permissions;
//           }
//         }
//       );
//   },
// });
// export const { addUserInState } = slice.actions;
// export default slice.reducer;



import { message } from "antd";
import { createSlice } from "@reduxjs/toolkit";

import { IAuthState } from "@types";
import { authApi } from "@services";
import { jwtDecode } from "jwt-decode";

const initialState: IAuthState = {
  user: null,
  token: {
    access: null,
    refresh: null,
  },
  permissions: [],
  applications: [],
  is_one_time_password: false,
};

const slice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    addUserInState: (state, { payload }) => {
      state.is_one_time_password = payload?.is_one_time_password;
      state.user = payload?.user;
      state.token = payload?.token;
      state.permissions = !payload?.permissions?.length
        ? ["all"]
        : payload?.permissions;
    },
  },
  extraReducers: builder => {
    builder
      .addMatcher(authApi.endpoints.logout.matchPending, (state, action) => {
        state.user = null;
        message.success("User has been successfully logout");
      })
    .addMatcher(
  authApi.endpoints.verify.matchFulfilled,
  (state, { payload }) => {
    try {
      // 🧩 Decode JWT access token
      const token = payload?.data?.token?.claims
      const claims: any = token ? jwtDecode(token) : {};

      console.log("Decoded claims:", claims);

      // 🧠 Merge decoded role into user
      const updatedUser = {
        ...payload?.data?.user,
        role: claims?.role, 
      };

      const permissions = claims?.permissions

      console.log("Original user:", updatedUser);


      // ✅ Handle one-time password vs normal verification
      if (payload?.data?.is_one_time_password) {
        state.is_one_time_password = true;
        state.token.access = token;
      } else {
        state.is_one_time_password = false;
        state.user = updatedUser;
        state.token = payload?.data?.token;
        state.applications =
          updatedUser?.company?.applications || [];
        state.permissions = !permissions?.length
          ? ["all"]
          : permissions;
      }
    } catch (error) {
      console.error("Error decoding token:", error);
    }
  }
);
  },
});
export const { addUserInState } = slice.actions;
export default slice.reducer;
